export const Locales = {
    EN: "en",
    DE: "de",
    FR: "fr"
};

export const DefaultLocale = Locales.DE;
